import { registerPlugin } from "@capacitor/core";

export const DriverCredentialVault = registerPlugin("DriverCredentialVault");
